import theme from "@/theme";
import { Stack, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import ButtonWithAnalytics from "../ButtonWithAnalytics";
import IconLoader from "../IconLoader";
import { useNavigate } from "react-router-dom";

interface GetSupportPanelProps {
  title?: string;
  subtitle?: string;
  buttonText?: string;
  onButtonClick?: () => void;
  icon?: string;
  analyticsPage?: string;
}

export default function GetSupportPanel({
  title = "common.getSupport.title",
  subtitle = "common.getSupport.subtitle",
  buttonText = "common.supportLink",
  onButtonClick,
  icon = "PadlockIcon",
  analyticsPage = "Get Support Panel",
}: GetSupportPanelProps) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Stack
      spacing={2}
      sx={{
        backgroundColor: theme.palette.primary[100],
        borderRadius: 2,
        padding: 2,
      }}
    >
      <Stack flexDirection="row" gap={1} alignItems="center">
        <IconLoader icon={icon} />

        <Typography variant="body2" component="h3" fontWeight="bold">
          {t(title as any)}
        </Typography>
      </Stack>
      <Stack>
        <Typography variant="body2">
          <Trans i18nKey={subtitle as any} />
        </Typography>
      </Stack>
      <ButtonWithAnalytics
        page={analyticsPage}
        text={t(buttonText as any)}
        intent="navigational"
        variant="outlined"
        color="neutral"
        onClick={() => {
          if (onButtonClick) {
            onButtonClick();
          } else {
            navigate("/home/more/get-support");
          }
        }}
        size="small"
      >
        {t(buttonText as any)}
      </ButtonWithAnalytics>
    </Stack>
  );
}
